// extracted by mini-css-extract-plugin
export var activityContainer = "_mh-0";
export var typingIndicatorContainer = "_mh-1";
export var typingIndicatorDot = "_mh-2";
export var wave = "_mh-3";